import { zodResolver } from '@hookform/resolvers/zod';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, CardContent, Checkbox, Chip, FormControl, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useTQuery } from '../../../../../utils/useTQuery';

// Define schema for form validation
export const roleSchema = z.object({
    // JOBROLE_ID: z.array(z.string()).min(1, { message: "At least one role must be selected" }),
    JOBROLE_ID: z.array(z.string()).optional(),
    IS_ALL_JOBROLE: z.boolean().optional(),
}).refine(
    (data) => {
        if (data.IS_ALL_JOBROLE) {
            return true;
        }
        return data.JOBROLE_ID.length > 0;
    },
    {
        message: "At least one role must be selected",
        path: ["JOBROLE_ID"],
    }

);

const AssignJobRole = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    console.log("values", values)
    const [checked, setChecked] = useState(values?.IS_ALL_JOBROLE || false);
    const [roles, setRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const { selectedTabData } = useSelector((state) => state.profileTabSection);
    console.log("selectedTabData", selectedTabData)
    const { data: rolesData } = useTQuery(
        "jobs_roles",
        "/jobRoles",
        "post"
    );

    useEffect(() => {
        if (rolesData?.STATUS) {
            setRoles(rolesData.OUTPUT);
        }
    }, [rolesData]);
    useEffect(() => {
        if (values.JOBROLE_ID) setSelectedRoles(values.JOBROLE_ID);
    }, [values])
    const {
        control,
        handleSubmit,
        setValue,
        setError,
        trigger,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: {
            DOCUMENT_NAME: values.DOCUMENT_NAME || values.value.DOCUMENT_NAME || "", REQUIREMENT: values?.REQUIREMENT || values.value.REQUIREMENT || ""
            , JOBROLE_ID: values?.JOBROLE_ID || [],
        },
    });

    const { mutateAsync } = useTMutation("/addHealthDocument", "post", (response) => {
        return response
    });

    const submitJobRole = async (formData) => {
        console.log("ess", formData)
        
        const value = {
            ...formData,
            ID: values?.ID,
            IS_ALL_JOBROLE: formData.JOBROLE_ID.length > 0 ? false : checked
        }

        try {
            const response = await mutateAsync(value);
            console.log("sdhhd", response.OUTPUT)
            if (response.STATUS) {
                dispatch(update({ value: response.OUTPUT }))
                dispatch(nextStep())
                showToast("success", response.MESSAGE, 3000);
            } else {
                showToast("error", response.MESSAGE, 3000);
            }

        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (roleId) => {
        setSelectedRoles((prev) => prev.filter(id => id !== roleId));
        setValue('JOBROLE_ID', selectedRoles.filter(id => id !== roleId));
        clearErrors('JOBROLE_ID');
    };

    const handleChecked = () => {
        const newCheckedState = !checked;
        setChecked(newCheckedState);
        setValue('IS_ALL_JOBROLE', newCheckedState);

        if (newCheckedState) {
            setSelectedRoles([]);
            setValue('JOBROLE_ID', []);
            setError()
        }
    };

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
            const updatedRoles = [...selectedRoles, selectedRoleId];
            setSelectedRoles(updatedRoles);
            setValue('JOBROLE_ID', updatedRoles);
            trigger('JOBROLE_ID')
        }
    };
    console.log("asdasd", roles, values)

    return (
        <>
            {!values.REDIRECT && <Button
                onClick={() => dispatch(previousStep())}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
            >
            </Button>}            
            
            <Grid lg={12} pt={3}>

                <CardContent>
                    <Typography variant="h2" component="div" mt={-6} fontWeight="bold">
                        Assign to job roles
                    </Typography>
                    <form onSubmit={handleSubmit(submitJobRole)}>
                        <Box sx={{ display: "flex", flexDirection: "column",  }}>
                            <FormControl fullWidth margin="normal">
                                <Controller
                                    name="JOBROLE_ID"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            label="Job Role"
                                            value=""
                                            onChange={handleRoleChange}
                                            disabled={checked === true}
                                            error={!!errors.JOBROLE_ID}
                                            helperText={errors.JOBROLE_ID?.message}
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: 1.814
                                                },
                                            }}
                                        >
                                            <MenuItem disabled value="">Select</MenuItem>
                                            {roles.map((role) => (
                                                <MenuItem key={role.ID} value={role.ID}>
                                                    {role.ROLE_NAME}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                            </FormControl>

                            {/* <Box sx={{ mt: 0.5 }}>
                                <Grid container spacing={2}>
                                    {selectedRoles.map((roleId) => (
                                        <Grid item xs={6} key={roleId}>
                                            <Chip
                                                label={roles.find(role => role.ID === roleId)?.ROLE_NAME}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box> */}


                               <Box style={{marginTop:-1}}>
                                <Grid container spacing={1}>
                                    {selectedRoles.map((roleId) => (
                                        <Grid item xs={4} key={roleId}>
                                            <Chip
                                                label={roles.find(role => role.ID === roleId)?.ROLE_NAME}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                <Controller
                                    name="IS_ALL_JOBROLE"
                                    control={control}
                                    render={({ field }) => (
                                        <Checkbox
                                            {...field}
                                            checked={checked}
                                            onChange={handleChecked}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: "#6ebe44"
                                                },
                                                '&:focus': {
                                                    outline: 'none'
                                                }
                                            }}
                                        />
                                    )}
                                /><Typography sx={{ padding: 1.694 }}>Set for all job roles</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                            <Typography
                              mt={1}
                              sx={{ color: "#000000", opacity: "60%", fontSize: "14px", cursor: "pointer" }}
                        // onClick={() => dispatch(nextStep())}
                    >
                        Skip
                    </Typography>
                                <Button 
                                 className='gradientAdminThemeColor'
                                // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                type='submit'>
                                    Next
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </CardContent>
            </Grid>
              
            

            
        </>
    );
};

export default memo(AssignJobRole);
